import { View } from '@react-pdf/renderer'
import { Style } from '@react-pdf/types'
import { ReactNode } from 'react'

import { commonPdfTableStyles } from '@features/exports/utils/commonTableStyles'

interface ReportsPdfTableRowProps {
  children: ReactNode
  customStyles?: Style
  fixed?: boolean
}

export const ReportsPdfTableRow = ({ children, customStyles, fixed = false }: ReportsPdfTableRowProps) => {
  return (
    <View wrap={false} style={[commonPdfTableStyles.row, customStyles || {}]} fixed={fixed}>
      {children}
    </View>
  )
}
